import Vue from 'vue';
import { getXemBookMosaicList } from "../../../lib/mosaicUtils";
import BalanceModule from "../../mixins/BalanceModule";
import ToolBar from '../../parts/ToolBar.vue';
const imageUrlsDefault = {};
export default Vue.extend({
    components: { ToolBar },
    mixins: [BalanceModule],
    name: "MosaicGallery",
    data() {
        return {
            imageUrls: Object.assign({}, imageUrlsDefault),
            targetName: '',
            targetNamespaceId: '',
            targetImageUrl: '',
            showDialog: false,
            loadingXemBookList: false,
            loadingMosaics: false,
        };
    },
    mounted() {
        this.updateImageUrl();
    },
    methods: {
        updateImageUrl() {
            this.loadingXemBookList = true;
            this.loadingMosaics = true;
            this.imageUrls = Object.assign({}, imageUrlsDefault);
            getXemBookMosaicList().then((json) => {
                for (let imageInfo of json) {
                    this.imageUrls[imageInfo.namespace + ':' + imageInfo.name] = imageInfo.url;
                }
                this.loadingXemBookList = false;
            });
            this.fetchBalance(true, (balance, mosaics) => {
                for (let mosaic of mosaics) {
                    const description = this.mosaicDescriptions[mosaic.mosaicId.description()];
                    if (description.includes('oa:')) {
                        const oaString = description.replace(/oa:/g, "");
                        this.imageUrls[mosaic.mosaicId.description()] = "https://s3.amazonaws.com/open-apostille-nemgallary-production/" + oaString + ".jpg";
                    }
                }
                this.loadingMosaics = false;
            });
        },
        openDialog(name, namespaceId, imageUrl) {
            this.targetName = name;
            this.targetNamespaceId = namespaceId;
            this.targetImageUrl = imageUrl;
            this.showDialog = true;
        },
        hasImage() {
            for (let mosaic of this.ownedMosaics) {
                if (mosaic.mosaicId.description() in this.imageUrls) {
                    return true;
                }
            }
            return false;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/gallery/MosaicGallery.vue
// module id = 657
// module chunks = 1